import React from 'react'
import Link from 'gatsby-link'
import './index.css'

const SubMenu = props => {
  var windowWidth = 1000
  var slug = ["a", "h", "o", "i"]
  if (typeof window !== 'undefined') {
    windowWidth = window.innerWidth
    slug = window.location.pathname.split('/')
  }
  return (
    <div style={{ textAlign: 'center' }}>
      {windowWidth < 700 && (
        <Link
          className="sublink"
          activeStyle={{
            fontWeight: '700'
          }}
          to={`/${slug[1]}/`}>
          {`${props.thisName}`}
        </Link>
      )}
      {props.freieArbeit && (
        <div>
          <Link
            className="sublink"
            activeClassName={'subcurrent'}
            to={`/${slug[1]}/hafengefluester/`}>
            Hafengeflüster
          </Link>
          <Link
            className="sublink"
            activeClassName={'subcurrent'}
            to={`/${slug[1]}/offseason/`}>
            Off Season
          </Link>
          <Link
            className="sublink"
            activeClassName={'subcurrent'}
            to={`/${slug[1]}/brotundspiele/`}>
            Brot und Spiele
          </Link>
          <Link
            className="sublink"
            activeClassName={'subcurrent'}
            to={`/${slug[1]}/humanstudies/`}>
            Human studies
          </Link>
        </div>
      )}
    </div>
  )
}

export default SubMenu



// WEBPACK FOOTER //
// ./src/components/SubMenu/index.js